import * as React from "react";

import Modal from "react-modal";

import { IRecurrence } from "../../classes/recurrencePattern";
import { IText } from "../../classes/text";
import { IText_AddEditEvent } from "../../classes/text_AddEditEvent";

import { ModalHtmlClassHack } from "../../../common/modalHtmlClassHack/ModalHtmlClassHack";
import { RecurrenceModalLoadingAndCloseButton } from "./RecurrenceModalLoadingAndCloseButton";

export interface IRecurrenceModal {
	addEditText: IText_AddEditEvent;
	currentStartDate: Date;
	dateOfFirstEventInRecurrence: Date;
	displayModal: boolean;
	firstDayOfWeek: string;
	isLoading: boolean;
	isFromTwoWayCalendar: boolean;
	isTwoWayCalendarEvent: boolean;
	onCloseModal: () => void;
	onUpdateRecurrence: (recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string) => void;
	portletInstanceId: number;
	recurrencePattern: IRecurrence;
	text: IText;
	userDateFormat: string;
}

export const RecurrenceModal: React.SFC<IRecurrenceModal> = (props) => {

	const parentElementSelector = "#portlet" + props.portletInstanceId + ".PO-calendar";
	const getParent = () => document.querySelector(parentElementSelector);

	// Using an useEffect hook to replace the componentDidMount lifecycle method that used to exist when this was a stateful React class component.
	React.useEffect(() => {
		Modal.setAppElement(parentElementSelector);
	});

	return (
		<>
			<ModalHtmlClassHack modalIsOpen={props.displayModal} />

			<Modal
				className={"ReactModal__Content"}
				isOpen={props.displayModal}
				onRequestClose={props.onCloseModal}
				overlayClassName={"ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog"}
				parentSelector={getParent}
				shouldCloseOnOverlayClick={true}
			>
				<RecurrenceModalLoadingAndCloseButton
					addEditText={props.addEditText}
					currentStartDate={props.currentStartDate}
					dateOfFirstEventInRecurrence={props.dateOfFirstEventInRecurrence}
					firstDayOfWeek={props.firstDayOfWeek}
					isLoading={props.isLoading}
					isFromTwoWayCalendar={props.isFromTwoWayCalendar}
					isTwoWayCalendarEvent={props.isTwoWayCalendarEvent}
					onCloseModal={props.onCloseModal}
					onUpdateRecurrence={props.onUpdateRecurrence}
					text={props.text}
					recurrencePattern={props.recurrencePattern}
					userDateFormat={props.userDateFormat}
				/>
			</Modal>
		</>
	);
};
